import styled, { css } from 'styled-components';

export const HeaderContainer = styled.div`
  gap: 8px;
  
${({ display }) => display && css`
    flex: 2;
    display: ${display};
  `}
`;

export const HighLightHeaderContainer = styled.div`
${({ isTablet, isDesktop }) => (isTablet || isDesktop) && css`
  display: flex;
`}

${({ isTablet }) => isTablet && css`
    flex: 1;
  `}
`;


export const HeaderTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-right: ${({ isDesktop }) => (isDesktop ? '36px' : '24px')};
`;

export const HighLightedHeaderText = styled.span`
  font-weight: ${({ title }) => (title ? '700' : '400')};
  font-size: ${({ title }) => (title ? '14px' : '16px')};
  line-height:  ${({ title }) => (title ? '10px' : '20px')};
  font-family: 'Work Sans';
`;

export const HighLightedHeaderWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  background-color: var(--luft-primary);
  padding: 8px 12px;
  border-radius: 4px 0px 0px 4px;
  color: var(--white);
  width: auto;

  ${({ extend }) => extend && css`
    flex: 1;
    border-radius: 4px 0px 0px 0px;
    margin-bottom: 2px;
  `}

  ${({ isMobile, up }) => isMobile && css`
    justify-content: center;
    border-radius: ${(up ? '4px 4px 0px 0px' : '0px 0px 4px 4px')};

    && ${HeaderTextBlock} {
      flex: 1;
      text-align: center;
      && ${HighLightedHeaderText} {
        font-size: 18px;
      }
    }
  `}
`;

export const HighLightedHeaderCTE = styled.span`
  font-size: 12px;
  line-height: 20px;
`;

export const HeaderDatesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ isMobile }) => (isMobile ? 'transparent' : '#e0e0e0')};
  padding: ${({ isDesktop }) => (isDesktop ? '8px 24px' : '8px 12px')};
  flex: 1;

  ${({ isMobile }) => isMobile && css`
    display: block;
    padding: 0;

    && ${HeaderTextBlock} {
      background-color: var(--gray-secondary-light);
      margin-bottom: 2px;
      align-items: center;
      justify-content: center;
      margin-right: 0;
      border-radius: 0;
      flex-direction: row;
      justify-content: space-between;
      padding: 8px 52px;

      &:first-child {
        border-radius: 4px 4px 0 0;
      }      
    }
  `};
`;

export const HeaderDatesText = styled.span`
  color: ${({ title }) => (title ? '#263465' : '#292F36')};
  font-weight: ${({ title }) => (title ? 'bold' : 'normal')};
  font-size: ${({ title }) => (title ? '14px' : '16px')};
  line-height: 14px;
  font-family: 'Work Sans';
`;

export const HeaderStatusWrapper = styled.div`
  border-radius: 0px 4px 4px 0px;
  padding: 19px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 168px;

  && > span {
    color: var(--white);
    text-transform: uppercase;
    font-weight: 700;
    font-size: 14px;
    line-height: 10px;
    font-family: 'Work Sans';
  }

  ${({ color }) => color && css`
    background-color: ${color};
  `}


  ${({ isTablet }) => isTablet && css`
    margin-left: 2px;
    border-radius: 0px 4px 0px 0px;
    margin-bottom: 2px;
    min-width: 138px;
  `}
  
  ${({ isMobile }) => isMobile && css`
    border-radius: 0 0 4px 4px;
    max-width: initial;
  `}

`;

export const NFAgContainer = styled.div`
  background-color: var(--light-blue);
  color: var(--white) !important;
  margin-left: 4px;
  padding: 0px 4px;
  border-radius: 4px;
  font-weight: bold;
  font-size: 8px;
  line-height: 8px;
  margin-bottom: 0;
  padding: 1px 2px;
`;
